var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8484 2.75147C12.3798 2.28284 11.62 2.28284 11.1514 2.75147L2.75137 11.1515C2.28275 11.6201 2.28275 12.3799 2.75137 12.8485C3.22 13.3172 3.9798 13.3172 4.44843 12.8485L4.7999 12.497V20.4C4.7999 21.0627 5.33716 21.6 5.9999 21.6H8.3999C9.06264 21.6 9.5999 21.0627 9.5999 20.4V18C9.5999 17.3373 10.1372 16.8 10.7999 16.8H13.1999C13.8626 16.8 14.3999 17.3373 14.3999 18V20.4C14.3999 21.0627 14.9372 21.6 15.5999 21.6H17.9999C18.6626 21.6 19.1999 21.0627 19.1999 20.4V12.497L19.5514 12.8485C20.02 13.3172 20.7798 13.3172 21.2484 12.8485C21.7171 12.3799 21.7171 11.6201 21.2484 11.1515L12.8484 2.75147Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.757aa8b3e0878d10a455c7136fdcafe2.svg";
export { ForwardRef as ReactComponent };